module.exports = __webpack_public_path__ + "img/blog-58.7b8468e4.jpg";